import { PAYMENT_INDICATORS } from '@/entities/payment/lib/indicators';
import { IPaymentTemplate } from '@/entities/payment/lib/serialize';

import {
  VabsPaymentDirection,
  VabsPaymentSystem,
} from '@/shared/api';
import { Human } from '@/shared/assets';
import { capitalize } from '@/shared/lib/utils/text';
import { AvatarWithIndicator, Typography } from '@/shared/ui';

interface PaymentProps {
  payment: IPaymentTemplate;
}
export const PaymentBar = ({ payment }: PaymentProps) => {
  const indicator = PAYMENT_INDICATORS[payment.direction];
  const amount = Number(payment.outAmount || 0) + Number(payment.fee || 0)
  return (
    <div className="flex w-full items-center rounded-[20px] bg-base-300 px-5">
      <div className="flex w-full items-start justify-between !min-h-[80px]">
        <div className="flex items-center">
          <AvatarWithIndicator
            indicator={indicator}
            className="py-4 pr-4"
            defaultAvatar={
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-base-100">
                <Human className="h-6 w-6" />
              </div>
            }
            avatar=""
          />
          <div className="flex flex-col gap-1.5 py-4">
            <Typography
              variant="16-r"
              className="overflow-hidden text-ellipsis max-w-[175px] md-max-w-[160px]"
            >
              {payment.paymentSystem !== VabsPaymentSystem.Inner && payment.companyName}
              {payment.paymentSystem === VabsPaymentSystem.Inner &&
                payment.name}
            </Typography>
            <Typography variant="14-r" color="text-base-100">
              {capitalize(payment.direction)}
            </Typography>
          </div>
        </div>
        {payment.direction === VabsPaymentDirection.Outgoing && (
          <div className="whitespace-nowrap py-4">
            - {amount?.toFixed(2)} {payment.currency?.symbol}
          </div>
        )}
        {payment.direction === VabsPaymentDirection.Incoming && (
          <div className="whitespace-nowrap py-4">
            + {payment.incAmount} {payment.currency?.symbol}
          </div>
        )}
      </div>
    </div>
  );
};
